import React, { useEffect, useState } from "react";
import {
  Alert, 
  AlertTitle,
  Modal,
  Tooltip,
  IconButton ,
  Typography,
  Card,
  Grid,
  Hidden,
  Paper,
  CardContent,
  InputLabel,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import requestMissingContexts, {determineConfigLong,determineConfig,displayConfig} from "../../utils/GetContext";
import { MissingVMConfig, MissingVMConfigs, GetEquipmentMissingConfig } from "../../utils/GetAdmin";
import { saveEquipmentCapacity, EquipmentCapacity } from "../../utils/PostAdmin";
import MUIDataTable, {MUIDataTableMeta} from "mui-datatables";
import {checkForRole} from "../../utils/GetAuth";
import AddIcon from '@mui/icons-material/Add';
import LockIcon from '@mui/icons-material/Lock';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import CriticalFailure from "src/pages/CriticalFailure";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
    },
    modalInput: {
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

export default function AdminEquipmentMissing() {
  const classes = useStyles();
  const [codes, setCodes] = React.useState<any>();
  const [missingConfigs, setMissingConfigs] = useState<MissingVMConfigs|undefined>();
  const [newConfig, setNewConfig] = useState<EquipmentCapacity|undefined>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [modalStyle] = React.useState(getModalStyle);
  const [showCritFail, setShowCritFail] = React.useState<boolean>(false);

  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })


  const handleAdd = (tableMeta:MUIDataTableMeta) => {
    let cur:any = tableMeta.currentTableData[tableMeta.rowIndex];
    setNewConfig({
      model: cur.data[0],
      packType:cur.data[1],
      packSize:cur.data[2],
      columnSingleCapacity:'0',
      nvcSingle:'0',
      columnDoubleCapacity:'0',
      nvcDouble:'0',
      machinecategory:'',
      columnWidth:'',
    })
  }

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES","PACKTYPE","PACKSIZE"]).then((v:any) => {setCodes(v);})
    GetEquipmentMissingConfig(salesOrg).then((v) => {
      setDoneLoading(true);
      if(v && !v.hadError){
        setMissingConfigs(v);} else {
          setShowCritFail(true);
        }
    });
  }, [missingConfigs, doneLoading, salesOrg]);

  const TABLE_DATA:MissingVMConfig[] = (missingConfigs)?missingConfigs.ml.concat(missingConfigs.cm).concat(missingConfigs.ob):[]

  function getTextDescription(code:string){
    let ret = code;
    if(missingConfigs?.texts){
      ret = (missingConfigs.texts.find(c=>c.code === code))?.text || code;
    }
    return ret;
  }

  function getEventValueString(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | {name?: string | undefined; value: unknown;}>){
    return (e.target.value &&  typeof e.target.value == 'string') ? e.target.value : ""
  }

  function isSameConfig(a:any,b:any){
    return a.model === b.model && a.packSize === b.packSize && a.packType === b.packType
  }

  function handleModalSave(){
    if(missingConfigs && newConfig){
      saveEquipmentCapacity(salesOrg,undefined,newConfig)
        .then((ret:any) => {
          if(ret && ret.data){
            let idx = ret.data.mdEquipmentModelCapacities.findIndex((emc:any)=>isSameConfig(emc,newConfig))
            if(idx >= 0){
              setMissingConfigs({
                ...missingConfigs,
                ml:missingConfigs.ml.filter(old=>!isSameConfig(old,newConfig)),
                cm:missingConfigs.cm.filter(old=>!isSameConfig(old,newConfig)),
                ob:missingConfigs.ob.filter(old=>!isSameConfig(old,newConfig)),
              })

            }
          }
        })
        .finally(()=>{setNewConfig(undefined)});
    }
  }

  // Check any error in Network API Response the restuen to the failure page
  if(showCritFail){
    return(
      <CriticalFailure title='Missing Equipment Capacity - ERROR'>
          <Typography >Failed to fetch the Missing Equipment Capacity!!!</Typography>
      </CriticalFailure>
    )
  } 

  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
            <MUIDataTable
              options={{
                draggableColumns: {
                  enabled: true,
                },
                rowsPerPageOptions: [25, 50, 100],
                tableBodyHeight: TABLE_BODY_HEIGHT,
                serverSide: false,
                selectableRows: "none",
                rowsPerPage: muiTable.rpp,
                onChangeRowsPerPage: (numberOfRows) => {
                  muiTable.rpp = numberOfRows;
                  setMuiTable(muiTable);
                },
              }}
              title="Missing Equipment Capacity"
              columns={[
                {
                  label: "Model",
                  name: "model",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Pack Type",
                  name: "packType",
                  options: {
                    searchable: true,
                    filter: true,
                    customBodyRender: (value: any) => {
                      return (
                          `${determineConfig(codes, "PACKTYPE", value)} - ${determineConfigLong(codes, "PACKTYPE", value)}`
                      );
                    },
                  },
                },
                {
                  label: "Pack Size",
                  name: "packSize",
                  options: {
                    searchable: true,
                    filter: true,
                    customBodyRender: (value: any) => `${determineConfig(codes, "PACKSIZE", value)}` || "",
                  },
                },
                {
                  label: "Detected In",
                  name: "typeFound",
                  options: {
                    searchable: true,
                    filter: true,
                    customBodyRender: (value: any) => getTextDescription(value) || value,
                  },
                },
                {
                  label: "Sales Orgs",
                  name: "salesOrgs",
                  options: {
                    searchable: false,
                    filter: false,
                  },
                },
                {
                  label: " ",
                  name: "remove",
                  options: {
                    filter: false,
                    setCellProps: () => ({ align: 'right' }),
                    customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => {
                      if(!!useCompact)
                        return (
                            <React.Fragment>
                              <Tooltip title={"Add Capacity Mapping"}>
                                <AddIcon 
                                  fontSize="small"  
                                  onClick={() => {handleAdd(tableMeta)}}/>
                              </Tooltip>
                            </React.Fragment>
                          );
                        else
                          return (
                              <React.Fragment>
                                <Tooltip title={"Add Capacity Mapping"}>
                                  <IconButton onClick={() => {handleAdd(tableMeta)}}>
                                    <AddIcon />
                                  </IconButton>
                                </Tooltip>
                              </React.Fragment>
                            );
                    },
                  },
                },
              ]}
              data={TABLE_DATA}
            />
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      {newConfig?(
        <Modal
          open={true}
          onClose={(event, reason) => {
              if (reason !== 'backdropClick') { // ignore backdrop click 
                setNewConfig(undefined)
              }
            }}
          >
            <div style={modalStyle} className={classes.paper} >
              <Typography variant="h4" className={classes.modalTitle} paragraph>Equipment Capacity</Typography>
              <Grid container spacing={2} className={classes.modalGrid}>
                <Grid item xs={12}>
                  <Card className={classes.modalCard}>
                    <CardContent>
                    <Grid container spacing={1} className={classes.modalGrid}>
                    <Grid item xs={12}>
                    <InputLabel >Model</InputLabel>
                      <TextField placeholder='Model' type='text'
                        disabled={true}
                        className={classes.modalInput}
                        value={newConfig.model}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel >Pack Type</InputLabel>
                      <TextField placeholder='Model' type='text'
                        disabled={true}
                        className={classes.modalInput}
                        value={`${determineConfig(codes, "PACKTYPE", newConfig.packType)} - ${determineConfigLong(codes, "PACKTYPE", newConfig.packType)}`}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel >Pack Size</InputLabel>
                      <TextField placeholder='Model' type='text'
                        disabled={true}
                        className={classes.modalInput}
                        value={`${determineConfig(codes, "PACKSIZE", newConfig.packSize)}` || newConfig.packSize}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel >Single Capacity</InputLabel>
                      <TextField placeholder='Single Capacity' type='number'
                        className={classes.modalInput}
                        value={newConfig.columnSingleCapacity}
                        onChange={(e) => setNewConfig({...newConfig, columnSingleCapacity:getEventValueString(e)})}
                        />

                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel >NVC Single</InputLabel>
                      <TextField placeholder='NVC Single' type='number'
                        className={classes.modalInput}
                        value={newConfig.nvcSingle}
                        onChange={(e) => setNewConfig({...newConfig, nvcSingle:getEventValueString(e)})}
                        />
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel >Double Capacity</InputLabel>
                        <TextField placeholder='Double Capacity' type='number'
                            className={classes.modalInput}
                            value={newConfig.columnDoubleCapacity}
                          onChange={(e) => setNewConfig({...newConfig, columnDoubleCapacity:getEventValueString(e)})}
                          />
                      </Grid>
                    <Grid item xs={6}>
                    <InputLabel >NVC Double</InputLabel>
                          <TextField placeholder='NVC Double' type='number'
                            className={classes.modalInput}
                            value={newConfig.nvcDouble}
                            onChange={(e) => setNewConfig({...newConfig, nvcDouble:getEventValueString(e)})}
                            />
                        </Grid>
                      </Grid>
                      </CardContent>
                    </Card>
                    <div style={{ paddingRight: "5px", textAlign:"right"}}>
                      <React.Fragment>
                          <Tooltip title={"Save"}>
                              <IconButton onClick={handleModalSave}>
                                  <SaveIcon />
                              </IconButton>
                          </Tooltip>
                          <Tooltip title={"Cancel"}>
                              <IconButton onClick={()=>{setNewConfig(undefined)}}>
                                  <Clear />
                              </IconButton>
                          </Tooltip>
                      </React.Fragment>
                    </div>
                  </Grid>
                </Grid>
              </div>
        </Modal>

      ):(<div/>)}
    </div>
  );
}